/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vogels (ignored)
// module id = 686
// module chunks = 0